import { Stack, Typography, Link, Box } from "@mui/material";
import { theme } from "../../theme";
import { WarningTriangleIcon, WarningOctagonIcon } from "../../assets/icons";
import getREMFromPX from "../../utils/getREMFromPX";
import useGetThemePath from "../../hooks/useGetThemePath";

type BannerFlavor = "warning" | "error";

interface BannerProps {
  flavor: BannerFlavor;
  message: string;
  action?: () => void;
  actionLabel?: string;
}

const Banner = ({
  flavor = "error",
  message,
  action,
  actionLabel,
}: BannerProps) => {
  const themePath = useGetThemePath();
  const colors = theme[themePath].colors;

  const flavorStyles = {
    warning: {
      backgroundColor: colors.notification.warning.primary,
      color: colors.form.primary,
    },
    error: {
      backgroundColor: colors.notification.error.primary,
      color: colors.white,
    },
  };

  const getIcon = () => {
    switch (flavor) {
      case "warning":
        return <WarningTriangleIcon fill={colors.icons.default.fillColor} />;
      case "error":
        return (
          <WarningOctagonIcon
            width="24"
            height="24"
            fill={colors.icons.viewBy.activeColor}
          />
        );
    }
  };

  return (
    <Stack
      direction="row"
      gap={2}
      sx={{
        padding: 1,
        justifyContent: "center",
        alignItems: "center",
        ...flavorStyles[flavor],
      }}
    >
      <Box sx={{ width: "24px", height: "24px" }}>{getIcon()}</Box>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: getREMFromPX(12),
          fontWeight: "700",
          color: flavorStyles[flavor].color,
        }}
      >
        {message}
      </Typography>
      {actionLabel && (
        <Link
          href="#"
          underline="always"
          onClick={action}
          sx={{
            fontFamily: "Inter",
            fontSize: getREMFromPX(12),
            fontWeight: "700",
            color: flavorStyles[flavor].color,
            textDecoration: "underline",
          }}
          style={{ cursor: "pointer" }}
        >
          {actionLabel}
        </Link>
      )}
    </Stack>
  );
};
export default Banner;
